<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 195.995"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <path
            class="fil1 str1"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            v-if="!noSegments"
            d="M60.741 122.644c8.751,-17.67 11.659,-37.78 8.723,-60.333 8.095,30.219 6.7,50.791 -4.184,61.715 -1.146,-0.409 -2.416,-0.704 -4.539,-1.382z"
        />
        <path
            class="fil1 str1"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            v-if="!noSegments"
            d="M31.95 120.542c-3.272,-18.908 -0.157,-38.997 9.343,-60.268 -16.765,27.657 -21.482,47.886 -14.152,60.687 1.232,-0.164 2.551,-0.192 4.809,-0.419z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.channel}"
            @click="select('channel')"
            d="M55.978 81.419c0.759,-21.037 4.956,-39.391 4.543,-41.274 -1.341,-1.563 -6.383,11.524 -11.468,45.587 1.233,-0.164 3.174,4.374 6.925,-4.313z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M32.985 177.136c-3.692,1.909 -7.468,4.405 -11.328,7.487 3.965,3.423 9.231,4.878 15.8,4.364 0.842,-0.473 1.668,-0.912 2.478,-1.316 8.743,-4.368 15.661,-4.765 20.757,-1.191 6.557,4.512 12.449,4.93 17.678,1.253 -7.976,-9.417 -16.575,-14.475 -25.797,-15.174 -6.244,-0.473 -12.773,1.053 -19.588,4.577z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M57.768 148.703c2.101,11.587 0.369,19.539 -5.195,23.856 9.222,0.699 17.821,5.757 25.797,15.174 2.23,-1.569 4.339,-3.881 6.327,-6.939 3.448,-12.495 3.48,-23.625 0.094,-33.392 -0.333,-0.807 -0.701,-1.754 -1.072,-2.923 -0.992,-0.646 -2.202,-1.244 -3.632,-1.794 -6.87,2.766 -14.31,4.772 -22.319,6.018z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M52.573 172.559c5.564,-4.317 7.296,-12.269 5.195,-23.856 -7.749,1.207 -16.031,1.702 -24.847,1.486 -0.023,8.883 -0.001,17.865 0.064,26.947 6.815,-3.524 13.344,-5.05 19.588,-4.577z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M32.985 177.136c-0.065,-9.082 -0.087,-18.064 -0.064,-26.947 -6.315,-0.155 -12.904,-0.674 -19.767,-1.558 -0.317,5.815 -0.185,12.198 0.395,19.147 1.321,7.704 4.024,13.318 8.108,16.845 3.86,-3.082 7.636,-5.578 11.328,-7.487z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M32.921 150.189c8.816,0.216 17.098,-0.279 24.847,-1.486 8.009,-1.246 15.449,-3.252 22.319,-6.018 -5.034,-1.935 -12.785,-3.276 -23.253,-4.021 -24.439,-4.847 -38.952,-2.248 -43.538,7.797 -0.055,0.714 -0.101,1.437 -0.142,2.17 6.863,0.884 13.452,1.403 19.767,1.558z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M47.919 44.649c4.068,-5.943 7.62,-10.178 10.653,-12.707 7.252,-5.237 9.989,-0.825 8.21,13.238m16.937 99.299c-4.482,-2.919 -13.444,-4.858 -26.885,-5.815 -24.439,-4.847 -38.952,-2.248 -43.538,7.797m1.662 -11.527c-2.017,8.997 -2.486,19.944 -1.409,32.844 2.604,15.182 10.573,22.252 23.908,21.209 9.922,-5.576 17.667,-6.412 23.235,-2.507 9.353,6.437 17.355,4.541 24.005,-5.686 3.448,-12.495 3.48,-23.625 0.094,-33.392 -1.061,-2.57 -2.475,-6.555 -3.214,-14.653 -0.739,-8.098 -0.803,-20.31 -1.06,-30.593 -0.257,-10.283 -0.707,-18.638 -0.9,-25.387 -0.193,-6.748 -0.129,-11.89 -0.772,-16.485 -0.642,-4.595 -1.992,-8.645 -3.309,-11.505 -1.318,-2.86 -2.603,-4.531 -3.728,-5.495 -1.125,-0.964 -2.089,-1.221 -3.278,-0.257 -1.189,0.964 -2.603,3.15 -4.114,7.423 -1.509,4.274 -3.116,10.638 -4.402,15.94 -1.285,5.302 -2.249,9.544 -3.181,12.564 -0.932,3.021 -1.832,4.82 -2.796,6.106 -0.964,1.285 -1.992,2.057 -3.085,1.896 -1.092,-0.16 -2.249,-1.253 -3.053,-3.214 -0.803,-1.96 -1.253,-4.787 -1.285,-9.993 -0.032,-5.206 0.354,-12.79 0.707,-17.611 0.353,-4.82 0.675,-6.876 0.642,-9.897 -0.032,-3.021 -0.417,-7.005 -0.899,-9.351 -0.482,-2.346 -1.061,-3.054 -2.346,-1.865 -1.286,1.189 -3.278,4.275 -4.949,7.199 -1.671,2.924 -3.02,5.688 -5.238,11.247 -2.217,5.56 -5.302,13.915 -7.616,21.402 -2.314,7.488 -3.856,14.108 -5.174,20.534 -1.317,6.428 -2.41,12.662 -3.374,18.928 -0.964,6.267 -1.8,12.565 -2.347,16.004 -0.546,3.438 -0.804,4.017 -1.062,4.595zm24.977 52.737c-0.558,2.251 0.32,3.717 2.633,4.398 7.186,0.791 13.227,-1.072 18.124,-5.589"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
